<script>
  import { chart } from "svelte-apexcharts";
  import { BigNumber } from "bignumber.js";
  import { optionsOpbouw }  from "./updateData";
  import { onDestroy, onMount } from "svelte";

  BigNumber.set({ 
                  DECIMAL_PLACES: 2,
                  FORMAT: {prefix: '€', decimalSeparator: ',', groupSeparator: '.',     groupSize: 3,
  }});
  
  let chartOptions;
  optionsOpbouw.subscribe(value => {chartOptions = value;});

  let shown = false;
  onMount(() =>
    setTimeout(() => {
      shown = true;
    }, 500)
  );

onDestroy(() => {optionsOpbouw.subscribe(value => {chartOptions = value;});});
</script>

{#if shown}
<div id="chart" use:chart={chartOptions}></div>
{/if}